import AppointmentListResourcePagingResultModel from '../../generated/types/model/resource/AppointmentListResourcePagingResultModel';
import ISchedulerList from '../interfaces/ISchedulerList';
import BaseSchedulerListMixin from '../mixin/BaseSchedulerListMixin';

export default class AppointmentListResourcePagingResultViewModel extends BaseSchedulerListMixin(AppointmentListResourcePagingResultModel) implements ISchedulerList {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
